import { useOfficeLocationFormState } from './useOfficeLocationFormState';
import { useOfficeLocationRegister } from './useOfficeLocationRegister';

export const useOfficeLocationForm = (formId: string | number) => {
  const formState = useOfficeLocationFormState(formId);
  const register = useOfficeLocationRegister(formId, formState);

  return {
    ...formState,
    register,
  };
};
